module.exports = __webpack_public_path__ + "static/section3-01279553693a849ad5c462951c73c8bc.svg";